import { useDispatch } from 'react-redux';
import useError from './useError';
import StatisticsLogVO from 'commons/vo/param/StatisticsLogVO';
import { useCallback } from 'react';
import KeyFlowError from 'commons/framework/KeyFlowError';
import { requestStatisticsLog } from 'redux/actions/statisticsLog/actions';

function useStatisticsLog() {
  const dispatch = useDispatch();

  const { onThrowError } = useError();

  const onRequestStatisticsLog = useCallback(
    (param: StatisticsLogVO) => {
      const { data, user } = param;
      if (!data || !user) {
        return;
      }

      dispatch(requestStatisticsLog({ param }));
    },
    [dispatch],
  );

  return { onRequestStatisticsLog };
}

export default useStatisticsLog;
